import { CoverageProcessParams } from 'src/domain/coverage-process'
import { CoverageProcessDto } from 'src/dto/coverage-process.dto'
import { CoverageProcessService } from 'src/services/api/coverage-process.service'

export class CoverageProcessController {
  private service: CoverageProcessService

  constructor() {
    this.service = new CoverageProcessService()
  }

  public async getCoverageProcessList(farmId: string): Promise<CoverageProcessDto[]> {
    const response = await this.service.getCoverageProcessList(farmId)
    return response.data
  }

  public async createCoverageProcess(
    farmId: string,
    coverageProcessDto: CoverageProcessParams
  ): Promise<CoverageProcessDto> {
    const response = await this.service.createCoverageProcess(farmId, coverageProcessDto)
    return response.data
  }

  public async updateCoverageProcess(
    farmId: string,
    coverageProcessDto: CoverageProcessParams
  ): Promise<CoverageProcessDto> {
    const response = await this.service.updateCoverageProcess(farmId, coverageProcessDto)
    return response.data
  }
}
